import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ListingDetails from '../components/ListingDetails'
import * as listingActions from '../actions/listings';

class ListingDetailsPage extends Component {

    render() {
        const urlParams = new URLSearchParams(window.location.search);
        const { publicPortal } = this.props;
        const listingId = urlParams.get('shareID') ?? this.props.match.params?.listingId;
        const publicId = this.props.match.params?.publicId;
        return (
            <div>
                <ListingDetails publicPortal={publicPortal} publicId={publicId} settings={this.props.settings} listingId={listingId} listingActions={this.props.listingActions} />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    listingActions: bindActionCreators(listingActions, dispatch)
});

export default connect(null, mapDispatchToProps)(ListingDetailsPage);